module.exports = __webpack_public_path__ + "static/media/profile-1.4173a2ba.jpeg";